var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal d-block",attrs:{"id":`modal-${_vm.id}`,"tabindex":"-1","role":"dialog"},on:{"keydown":_vm.checkKeyEvent}},[_c('div',{staticClass:"modal-dialog modal-dialog-scrollable",class:_vm.classes,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }